import clsx from "clsx";
import { Typography } from "../Typography";
import styles from "./FileType.module.scss";

export function FileType({ type, isError = false }: { type: string; isError?: boolean }) {
  return (
    <div className={clsx(styles.container, isError && styles.error)}>
      <p>{type}</p>
    </div>
  );
}
